import { axios } from "..";

export interface IReferral {
    id: string;
    legacyId?: number | string;
    referralDate?: number | null;
    fromDate?: number | null;
    toDate?: number | null;
    isMultiYear?: boolean;
    sendById?: number | string;
    sendByCosmosId?: string;
    sendByName?: string;
    firmById?: number | string;
    firmByCosmosId?: string;
    firmByName?: string;
    firmByLogo?: string;
    sendToId?: number | string;
    sendToCosmosId?: string;
    sendToName?: string;
    firmToId?: number | string;
    firmToCosmosId?: string;
    firmToName?: string;
    firmToLogo?: string;
    detail?: string;
    estimatedFees: number;
    estimatedFeesDetail?: string;
    submissionDate?: number | string;
    submittedByContact?: number | string;
    submittedByFirmLegacyId?: number;
    submittedByFirmCosmosId?: string;
    submittedByFirmName?: string;
    referralTypeId?: number;
    referralType: string;
    relationshipType?: string;
    storyId?: string;
    isDeleted?: boolean;
    type?: number | string;
    createdDate?: number;
    updatedDate?: number;
    canEdit?: boolean;
    canViewDetail?: boolean;
    showPartyNames?: boolean;
    showFees?: boolean;
}

export interface ReferralWriteBody {
    id?: string;
    relationshipType: "referral" | "collaboration";
    isMultiYear: boolean;
    referralDate?: string | null;
    fromDate?: string | null;
    toDate?: string | null;
    firmByCosmosId: string;
    sendByCosmosId: string;
    firmToCosmosId: string;
    sendToCosmosId: string;
    referralTypeId: number;
    otherType?: string;
    estimatedFees: number;
    detail: string;
    storyId?: string;
}

export interface ReferralListResult {
    items: IReferral[];
    total: number;
    page: number;
    pageSize: number;
}

export interface ReferralStats {
    sent: number;
    received: number;
    collaborations: number;
    feeBandTotal: number;
    months: number | null;
    feeMonths: number;
}

export const getFirmReferrals = async (firmId: number, limit: number = 100, sortOrder: "asc" | "desc" = "desc"): Promise<IReferral[]> => {
    const params = new URLSearchParams({
        firmId: firmId.toString(),
        limit: limit.toString(),
        sortOrder,
    });
    const response = await axios.Get(`/referral?${params.toString()}`);
    return response.data;
};

export const listReferrals = async (query: Record<string, string | number | undefined>): Promise<ReferralListResult> => {
    const params = new URLSearchParams();
    Object.entries(query).forEach(([key, value]) => {
        if (value !== undefined && value !== "") {
            params.set(key, String(value));
        }
    });
    const response = await axios.Get(`/referral?${params.toString()}`);
    return response.data;
};

export const getReferral = async (id: string): Promise<IReferral> => {
    const response = await axios.Get(`/referral?id=${encodeURIComponent(id)}`);
    return response.data;
};

export const getReferralByLegacyId = async (legacyId: string): Promise<IReferral> => {
    const response = await axios.Get(`/referral?legacyId=${encodeURIComponent(legacyId)}`);
    return response.data;
};

export const createReferral = async (body: ReferralWriteBody): Promise<IReferral> => {
    const response = await axios.Post("/referral", body);
    return response.data;
};

export const updateReferral = async (body: ReferralWriteBody): Promise<IReferral> => {
    const response = await axios.Put("/referral", body);
    return response.data;
};

export const deleteReferral = async (id: string): Promise<void> => {
    await axios.Delete("/referral", id);
};

export const getReferralStats = async (firmId?: number, firmCosmosId?: string): Promise<ReferralStats> => {
    const params = new URLSearchParams({ stats: "1" });
    if (firmId) {
        params.set("firmId", String(firmId));
    }
    if (firmCosmosId) {
        params.set("firmCosmosId", firmCosmosId);
    }
    const response = await axios.Get(`/referral?${params.toString()}`);
    return response.data;
};
